<template>
  <el-row v-if="isSend">
    <el-col :span="colSpan">
      <channels-select-group
        :title="$t('CampaignForm_ChannelsSelect_PushChannels')"
        :channels="pushChannels"
        v-model="value"
      />
    </el-col>

    <el-col :span="colSpan">
      <channels-select-group
        :title="$t('CampaignForm_ChannelsSelect_ApplicationChannels')"
        :channels="applicationChannels"
        :platforms="mobilePlatforms"
        v-model="value"
      />
    </el-col>

    <el-col :span="colSpan">
      <channels-select-group
        :title="$t('CampaignForm_ChannelsSelect_OpenChannels')"
        :channels="openChannels"
        v-model="value"
      />
    </el-col>

    <el-col :span="colSpan" v-if="hasSocialChannels">
      <channels-select-group
        :title="$t('CampaignForm_ChannelsSelect_SocialChannels')"
        :channels="socialChannels"
        v-model="value"
      />
    </el-col>
  </el-row>

  <el-row v-else>
    <el-col :span="colSpan">
      <channels-select-group
        :title="$t('CampaignForm_ChannelsSelect_DisplayChannels')"
        :channels="displayChannels"
        :platforms="mobilePlatforms"
        v-model="value"
      />
    </el-col>
  </el-row>
</template>

<script>
import ChannelsSelectGroup from './ChannelsSelectGroup'
import { $hasFeature } from '@/core/utils/VueAcl'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import {
  channelLabels,
  channelIcons,
  channelGroupLabels
} from '@/modules/campaign-manage/enum/Labels'

export default {
  name: 'ChannelsSelect',
  components: { ChannelsSelectGroup },

  props: {
    value: {
      required: true
    }
  },

  mounted() {
    this.$store.dispatch('refreshPlatformChannels')
  },

  computed: {
    pushChannels() {
      return [
        {
          field: 'ios_push',
          icon: channelIcons['ios_push'],
          title: this.$t(channelLabels['ios_push']),
          configured: $hasFeature('iosPush'),
          consent: 'push'
        },
        {
          field: 'android_push',
          icon: channelIcons['android_push'],
          title: this.$t(channelLabels['android_push']),
          configured: $hasFeature('androidPush'),
          consent: 'push'
        },
        {
          field: 'web_push',
          icon: channelIcons['web_push'],
          title: this.$t(channelLabels['web_push']),
          configured: $hasFeature('webPush'),
          consent: 'push'
        }
      ]
    },

    applicationChannels() {
      return [
        {
          field: 'inapp',
          icon: channelIcons['inapp'],
          title: this.$t(channelGroupLabels['inapp']),
          configured: $hasFeature('inapp'),
          platforms: {
            ios: {
              field: 'inapp_ios',
              configured: $hasFeature('inapp_ios')
            },
            android: {
              field: 'inapp_android',
              configured: $hasFeature('inapp_android')
            }
          }
        },
        {
          field: 'onsite',
          icon: channelIcons['onsite'],
          title: this.$t(channelLabels['onsite']),
          configured: $hasFeature('onsite')
        },
        {
          field: 'inbox',
          icon: channelIcons['inbox'],
          title: this.$t(channelLabels['inbox']),
          configured: $hasFeature('inbox')
        }
      ]
    },

    displayChannels() {
      return [
        {
          field: 'inapp',
          icon: channelIcons['inapp'],
          title: this.$t(channelLabels['inapp']),
          configured: $hasFeature('inapp'),
          platforms: {
            ios: {
              field: 'inapp_ios',
              configured: $hasFeature('inapp_ios')
            },
            android: {
              field: 'inapp_android',
              configured: $hasFeature('inapp_android')
            }
          }
        },
        {
          field: 'onsite',
          icon: channelIcons['onsite'],
          title: this.$t(channelLabels['onsite']),
          configured: $hasFeature('onsite')
        }
      ]
    },

    openChannels() {
      return [
        {
          field: 'email',
          icon: channelIcons['email'],
          title: this.$t(channelLabels['email']),
          configured: $hasFeature('email'),
          consent: 'email'
        },
        {
          field: 'sms',
          icon: channelIcons['sms'],
          title: this.$t(channelLabels['sms']),
          configured: $hasFeature('sms'),
          consent: 'sms'
        },
        {
          field: 'webhook',
          icon: channelIcons['webhook'],
          title: this.$t(channelLabels['webhook']),
          configured: $hasFeature('webhook')
        }
      ]
    },

    socialChannels() {
      return [
        {
          field: 'whatsapp',
          icon: channelIcons['whatsapp'],
          title: this.$t(channelLabels['whatsapp']),
          configured: $hasFeature('whatsapp')
        },
        {
          field: 'facebook',
          icon: channelIcons['facebook'],
          title: this.$t(channelLabels['facebook']),
          configured: $hasFeature('facebook')
        }
      ]
    },

    hasSocialChannels() {
      return !!this.socialChannels.find(item => {
        return item.configured
      })
    },

    allPlatforms() {
      return [
        ...this.mobilePlatforms,
        {
          code: 'web',
          icon: 'channel-webpush',
          name: this.$t('CampaignForm_ChannelsSelect_WebApps')
        }
      ]
    },

    mobilePlatforms() {
      return [
        {
          code: 'ios',
          icon: 'channel-apple',
          name: this.$t('CampaignForm_ChannelsSelect_IosApps')
        },
        {
          code: 'android',
          icon: 'channel-android',
          name: this.$t('CampaignForm_ChannelsSelect_AndroidApps')
        }
      ]
    },

    colSpan() {
      if (this.isSend) {
        return this.hasSocialChannels ? 6 : 8
      } else {
        return 24
      }
    },

    isChanged() {
      return this.value.diff && this.value.diff.includes('channels')
    },

    isSend() {
      return this.value.type === campaignTypeEnum.TYPE_NOTIFICATION
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/ChannelsSelect.vue